import { clearTokens, getCurrentToken } from '@/api/auth';

// IMPORTANT: API_URL already includes the /v1 prefix (e.g., http://localhost:8080/v1)
// Do NOT add /v1 to routes - this will cause double prefix errors (/v1/v1/...)
const API_URL = import.meta.env.VITE_API_URL;

export interface StwFetchError {
  status: number;
  error: string;
  message: string;
}

const stwFetch = async (
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  route: string,
  body: object | FormData = {}
): Promise<any> => {
  // Get current token with auto-refresh
  const token = await getCurrentToken();
  const isMultipartBody = body instanceof FormData;

  const requestOptions: RequestInit = {
    method,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(!isMultipartBody ? { 'Content-Type': 'application/json' } : {}),
    },
  };

  if (method !== 'GET') {
    requestOptions.body = isMultipartBody ? body : JSON.stringify(body);
  }

  const response = await fetch(`${API_URL}${route}`, requestOptions);
  const responseData = await response.json();

  if (response.status === 200) {
    return responseData.data;
  } else {
    // Handle token expiration
    if (response.status === 401 && responseData.code === 'TOKEN_EXPIRED') {
      // Token refresh already attempted in getCurrentToken(), so this is a hard failure
      clearTokens();

      // Redirect to login if we're not already on an auth page
      if (!window.location.pathname.includes('/auth/')) {
        window.location.href = '/auth/login';
      }
    }

    throw {
      status: response.status,
      error: responseData.error,
      message: responseData.message || responseData.error,
    } as StwFetchError;
  }
};

export { stwFetch };
